import React from 'react';
import { translations } from '../i18n/translations';

const tr = (key) => {
  let lang = 'en';
  try { lang = localStorage.getItem('mytownly_rides_lang') || 'en'; } catch { /* */ }
  const path = key.split('.');
  const pick = (obj) => path.reduce((o, k) => (o == null ? o : o[k]), obj);
  return pick(translations[lang]) ?? pick(translations.en) ?? key;
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="rapido-screen rapido-loading-screen" style={{ padding: 24, textAlign: 'center' }}>
          <div className="rapido-loading-auto" style={{ fontSize: 48, marginBottom: 16 }}>🛺</div>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0f172a', marginBottom: 8 }}>
            {tr('app.errorTitle')}
          </h2>
          <p className="text-muted" style={{ fontSize: 14, marginBottom: 16, maxWidth: 320 }}>
            {tr('app.errorBody')}
          </p>
          {this.state.error?.message && (
            <div style={{ fontSize: 12, color: '#ef4444', background: '#fee2e2', padding: '6px 12px', borderRadius: 8, marginBottom: 20, maxWidth: 320, wordBreak: 'break-word' }}>
              {this.state.error.message}
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%', maxWidth: 280 }}>
            <button
              type="button"
              className="btn btn-primary btn-lg"
              onClick={this.handleReload}
              style={{ width: '100%' }}
            >
              🔄 {tr('app.reloadScreen')}
            </button>
            <button
              type="button"
              className="btn btn-outline"
              onClick={this.handleGoHome}
              style={{ width: '100%' }}
            >
              🏠 {tr('app.returnHome')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
